export default "__VITE_ASSET__O2J99QSF__"